import { useQuery } from '@tanstack/react-query';
import { getOpenIssues } from '../services/AnalyticReportsService';
export default function useOpenIssues(filters, issueType, enabled, page = 1, perPage = 10, technicianIds = [], buildingIds = [], sortBy = null, sortDirection = undefined) {
    return useQuery([
        'openIssues',
        filters.values.dateRange,
        issueType,
        page,
        perPage,
        technicianIds,
        buildingIds,
        sortBy,
        sortDirection
    ], () => getOpenIssues(filters, issueType, page, perPage, technicianIds, buildingIds, sortBy, sortDirection), {
        staleTime: 5 * 60 * 1000,
        cacheTime: 30 * 60 * 1000,
        enabled,
        keepPreviousData: true
    });
}
